<button mat-flat-button
        type="button"
        appLongPress
        [minTime]="50"
        [maxTime]="maxTime"
        [title]="title"
        [disabled]="disabled"
        (longPress)="onLongPress()"
        (longPressing)="onLongPressing($event)"
        (releasePressing)="onReleasePressing()">
  <mat-icon *ngIf="!this.pressing">{{ this.icon }}</mat-icon>
  <mat-icon *ngIf="this.pressing">
    <mat-progress-spinner diameter="20"
                          mode="determinate"
                          strokeWidth="20%"
                          [value]="this.progress">
    </mat-progress-spinner>
  </mat-icon>
</button>
